
import { createVuetify } from 'vuetify';

import { ar } from 'vuetify/locale';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';

export default createVuetify({
  components,
  directives,
  locale: {
    locale: 'ar',
    fallback: 'ar',
    messages: { ar },
  }
});
